export default __webpack_public_path__ + "static/media/late.9a4fad64.svg";